import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=cf6f7286&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=cf6f7286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6f7286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6f7286')) {
      api.createRecord('cf6f7286', component.options)
    } else {
      api.reload('cf6f7286', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=cf6f7286&scoped=true&", function () {
      api.rerender('cf6f7286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zCDZhw8C4LOg/JS/comp/GuestBox.vue"
export default component.exports